<script setup lang="ts">
const { isMobile } = useBreakpoints()

const data = [
  {
    title: 'Fitur Keyboard KiriminAja',
    icon: 'material-symbols:verified',
    items: [
      {
        title: 'Auto Text & Balasan Tersimpan',
        description:
          'Gunakan template balasan instan untuk mempercepat respon pelanggan.'
      },
      {
        title: 'Cek Ongkos Kirim & Link COD Langsung dari Chat',
        description:
          'Hitung ongkir & kirim link pembayaran tanpa buka dashboard.'
      },
      {
        title: 'Lacak Paket Terkirim',
        description: 'Cek status resi langsung dari chat pelanggan.'
      },
      {
        title: 'Pembuatan Format Order Otomatis',
        description:
          'Format order langsung dari keyboard siap dikirim ke sistem KiriminAja.'
      }
    ]
  },
  {
    title: 'Efisiensi Operasional',
    icon: 'material-symbols:verified',
    items: [
      {
        title: 'Hemat Waktu CS dan Tim Operasional',
        description:
          'Semua fungsi pengiriman bisa diakses langsung dari keyboard.'
      },
      {
        title: 'Respons Lebih Cepat ke Pelanggan',
        description: 'Chat real-time tanpa harus buka dashboard terpisah.'
      },
      {
        title: 'Terintegrasi dengan Akun KiriminAja',
        description: 'Data cek ongkir, resi, dan COD sinkron otomatis.'
      },
      {
        title: 'Praktis untuk Semua Tim',
        description:
          'Owner, admin, dan customer service bisa pakai dengan login yang sama.'
      }
    ]
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16"
  >
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="Keyboard KiriminAja Kirim Paket Langsung dari Chat Bisnis Anda"
        description="Tingkatkan efisiensi kerja tim logistik dan customer service dengan shortcut praktis untuk operasional harian: cek ongkir, buat paket, dan kirim link COD tanpa pindah aplikasi."
      />
      <div class="flex gap-12">
        <div class="flex-1 flex flex-col gap-3">
          <div
            v-for="(value, index) in data"
            :key="index"
            class="py-4 px-6 rounded-3xl bg-surface-container-lowest flex flex-col gap-3"
          >
            <div
              class="flex items-center gap-4 py-3 px-4 rounded-3xl bg-on-primary-container"
            >
              <Icon
                class="text-primary flex-none"
                :name="value.icon"
                :size="isMobile ? '28px' : '32px'"
              />
              <p
                class="flex-1 text-lg lg:text-xl font-bold text-primary-purple"
              >
                {{ value.title }}
              </p>
            </div>
            <div
              class="flex flex-col gap-3 py-3 px-4 rounded-3xl bg-surface-container-low"
            >
              <div
                v-for="(item, indexItem) in value.items"
                :key="indexItem"
                class="flex flex-col"
              >
                <p class="font-semibold">{{ item.title }}</p>
                <p class="text-outline">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="hidden lg:block flex-1 max-w-[520px] rounded-3xl overflow-hidden"
        >
          <NuxtImg
            alt="keyboard kiriminaja"
            src="/images/aplikasi-mobile-banner-4.webp"
            class="w-full h-full object-contain"
          />
        </div>
      </div>
    </UiContainer>
  </div>
</template>
